import React from 'react';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';
import MailOutlineRounded from '@material-ui/icons/MailOutlineRounded';
import CallRounded from '@material-ui/icons/CallRounded';

import styles from './styles';
import view from '../../../Enums';
import Component from '../../Component';
import { withResizer } from '../../../HoCs';
import { guc } from '../../../services/Localisation';
import { isEmptyList, isEmptyString, merge } from '../../../utils';
import OYOLogo from '../../../resources/vectors/oyo';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent } from '../../../services/Analytics';
import { getCtaLinkWithUtmParams } from '../../../utils/campaignUtils';

class SimpleHeader extends Component {

    styles = styles;

    getViewMode = () => this.getWidth() > 1024 ? view.DESKTOP : this.getWidth() >= 750 ? view.TAB : view.MOBILE;

    renderLogo = () => typeof this.props.renderLogo === 'function' ? this.props.renderLogo() : <OYOLogo color='var(--theme-color)' style={this.gs('oyo_logo')} />;

    onActionClicked = event_action => logEvent(EVENT_CATEGORIES.STATIC_HEADER, event_action);

    renderAction = ({ Icon, text, href, event_action = text }, index) => text && href && <a key={index} style={this.gs('action')} href={href} target='_blank' onClick={() => this.onActionClicked(event_action)}>
        <Icon fontSize='small' style={this.gs('action_icon')} /><span style={this.gs('action_text')}>{text}</span>
    </a>;

    defaultActions = [
        { Icon: MailOutlineRounded, text: guc('email'), href: guc('email_us_link'), event_action: EVENT_ACTIONS.EMAIL_US_LINK_CLICKED },
        { Icon: CallRounded, text: guc('call'), href: guc('call_us_link'), event_action: EVENT_ACTIONS.CALL_US_LINK_CLICKED },
    ];

    render = () => {
        const { disableHomeLink = false, homeLinkLabel, actions, style } = this.props;
        return <div style={merge(this.gs('container'), style)}>
            <a href={getCtaLinkWithUtmParams('/')}>{this.renderLogo()}</a>
            <div style={this.gs('actions')}>
                {!disableHomeLink && <a href={getCtaLinkWithUtmParams('/')} style={this.gs('action')}>
                    <ArrowBackRounded style={this.gs('back_link_arrow')} />
                    <div style={{ marginLeft: 4 }}>{isEmptyString(homeLinkLabel) ? guc('partner_page') : homeLinkLabel}</div>
                </a>}
                {(isEmptyList(actions) ? this.defaultActions : actions).map(this.renderAction)}
            </div>
        </div>;
    }

}

export default withResizer(SimpleHeader);
